
import { Component } from "vue-property-decorator";
import PaperResultAiH5 from "@/views/paper/paper-result-ai-h5.vue";
import ResultTs from "@/views/paper/ts/result-ai";
import request from "@/lib/request/request";
import Draw from "./component/draw.vue";
import H5Dialog from "./component/dialog.vue";

@Component({
  components: { H5Dialog, Draw, PaperResultAiH5 }
})
export default class H5Mark extends ResultTs {
  showScrollTop = false;
  editing = false;
  resultStatus = 0;
  resultMaxlength = 200;
  resultText = "";
  markStatusOptions = [
    { label: "通过", labelRes: "已通过", value: 1, class: "pass" },
    { label: "待定", labelRes: "待定", value: 2, class: "wait" },
    { label: "拒绝", labelRes: "已拒绝", value: 3, class: "reject" }
  ];
  submitting = false;
  showDialog = false;
  dialogType = "success";
  dialogInfo = {
    loading: {
      isLoading: true,
      text: "提交中..."
    },
    success: {
      isLoading: false,
      text: "提交成功"
    },
    fail: {
      isLoading: false,
      text: "提交失败"
    }
  };

  get viewing() {
    return !this.editing;
  }

  get markStatus() {
    const option = this.markStatusOptions.find(
      item => item.value === this.candidate.auditStatus
    );
    return option || { label: "", labelRes: "", value: 0, class: "" };
  }

  created() {
    this.connectCode = this.$route.query.connectCode as string;
    this.isStudent = String(this.$route.query.ver || "") === "1";
    //鉴权
    if (this.$route.query.tid) {
      this.tid = String(this.$route.query.tid);
    }
    this.open().then(() => {
      this.resultStatus = this.candidate.auditStatus;
      this.resultText = this.candidate.auditDesc;
    });
  }

  handleShowScrollTop(show: boolean) {
    console.log("asdfasdfasdfa!!!!!" + show);
    this.showScrollTop = show;
  }

  handleShowShare() {
    (this.$refs.paperRef as any)?.handleShowShare();
  }
  tid = "";
  //交卷
  submit() {
    if (this.submitting || this.resultStatus === 0) return;
    if (this.resultText.length > this.resultMaxlength) {
      this.$message.error("评价内容不能超过" + this.resultMaxlength + "字");
      return;
    }

    this.showDialog = true;
    this.dialogType = "loading";

    request
      .post("aiExam/auditPublic/submit", {
        connectCode: this.connectCode,
        auditStatus: this.resultStatus,
        auditDesc: this.resultText,
        tid: this.tid
      })
      .then((resp: { data: any }) => {
        if (resp.data.code === 0) {
          this.editing = false;
          this.candidate.auditDesc = this.resultText;
          this.candidate.auditStatus = this.resultStatus;
          (this.$refs.paperRef as any)?.open();
          this.dialogType = "success";
          this.updateListData();
        } else {
          this.dialogType = "fail";
        }
      });
  }
  updateListData() {
    sessionStorage.setItem("h5UpdateCandidateConnectCode", this.connectCode);
  }
}
